import React, { PropsWithChildren } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import DateSelector from 'Components/Common/DateSelector';
import { FormGroupDateProps } from 'Components/Common/Form/FormGroupDate/form-group-date';
import MessageError from 'Components/Common/MessageError';
import { labelRequire, labelRequireChip } from 'Components/Common/Form/FormLabel';
import HintTextField from 'Components/Common/Form/HintTextField';

function FormGroupDate({
  label,
  labelMd,
  colMd,
  classForm,
  classLabel,
  classSubcontent,
  onChange,
  children,
  classCol,
  errorMessage,
  selected,
  register,
  compareMinDate = false,
  minDate,
  maxDate,
  disabled = false,
  showTimeSelectOnly = false,
  minTime,
  maxTime,
  placeholder,
  dateFormat,
  colDP = 12,
  subContent,
  hintText = '',
  showTime = true,
  isDefaultSetTime,
  isLabelRequireChip,
  isSubRequired,
  styleLabel,
  styleCol,
  labelWrapperClass,
}: PropsWithChildren<FormGroupDateProps>): JSX.Element {
  return (
    <Form.Group as={Row} className={`mb-3 ${classForm || ''}`}>
      <Form.Label column md={labelMd} style={styleLabel} className={labelWrapperClass}>
        {isLabelRequireChip && label ? (
          labelRequireChip(label, classLabel, isSubRequired)
        ) : label ? (
          labelRequire(label)
        ) : (
          <></>
        )}
      </Form.Label>
      <Col md={colMd} className={classCol} style={styleCol}>
        <Row>
          <Col md={colDP} className="px-0">
            {children ?? (
              <DateSelector
                {...register}
                dateFormat={dateFormat}
                placeholder={placeholder}
                selected={selected}
                onChange={(date) => onChange && onChange(date)}
                disabled={disabled}
                minDate={minDate}
                maxDate={maxDate}
                showTimeSelectOnly={showTimeSelectOnly}
                minTime={minTime}
                maxTime={maxTime}
                compareMinDate={compareMinDate}
                showTime={showTime}
                isDefaultSetTime={isDefaultSetTime}
              />
            )}
            {subContent && <p className={`fs-12 mt-1 ${classSubcontent}`}>{subContent}</p>}
          </Col>
          <HintTextField hintText={hintText} />
          <MessageError classWrapper="ms-2 px-0" message={errorMessage} />
        </Row>
      </Col>
    </Form.Group>
  );
}
export default FormGroupDate;
